import type { ModelingFormat } from 'balus-common';

// modelingFormat (CJK / LATIN) の表示文言用 i18n キーを集約。
// group の「デフォルト設定」と workspace の「個別設定」で別パスに翻訳キーが分かれているため
// 2 種類用意している。t() には常に静的な完全 i18n キーを渡す方針 (locales/README.md 参照)。
export const GROUP_DEFAULT_MODELING_FORMAT_I18N_KEYS = {
  CJK: 'group.defaultModelingFormat.format.CJK',
  LATIN: 'group.defaultModelingFormat.format.LATIN',
} as const satisfies Record<ModelingFormat, string>;

export const WORKSPACE_MODELING_FORMAT_I18N_KEYS = {
  CJK: 'workspace.modelingFormat.format.CJK',
  LATIN: 'workspace.modelingFormat.format.LATIN',
} as const satisfies Record<ModelingFormat, string>;
